/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentResumeeEnrollmentsTabViewModel } from "../types/StudentResumeeEnrollmentsTabViewModel.ts";
import { studentResumeeEnrollmentViewModelSchema } from "./studentResumeeEnrollmentViewModelSchema.ts";

export const studentResumeeEnrollmentsTabViewModelSchema = z.object({
  fullName: z.string().nullish(),
  gradeEditable: z.optional(z.boolean()),
  companyId: z.number().int().nullish(),
  companyProfile: z.string().nullish(),
  companyUnit: z.string().nullish(),
  companyStartDate: z.string().datetime().nullish(),
  companyEndDate: z.string().datetime().nullish(),
  creationDate: z.string().datetime().nullish(),
  lastChangeDate: z.string().datetime().nullish(),
  userCreation: z.string().nullish(),
  userLastChange: z.string().nullish(),
  enrollments: z
    .array(z.lazy(() => studentResumeeEnrollmentViewModelSchema))
    .describe("Lista de matrículas do aluno exibida na aba de matrículas.")
    .nullish(),
}) as unknown as ToZod<StudentResumeeEnrollmentsTabViewModel>;
